import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "f-ui-edited-message" }
const _hoisted_2 = { class: "first" }
const _hoisted_3 = { class: "last" }

import {ArrowNarrowRight, DotsVertical} from "utruckin-icons";
import {IMessageHistory} from "@/types/main";


export default /*@__PURE__*/_defineComponent({
  __name: 'editedMessage',
  props: {
    history: { default: undefined },
    lastText: { default: "" },
    lastTime: {},
    lastId: {}
  },
  emits: ["showHistory"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const showHistory = () => {
  let newHistory: IMessageHistory[] = [...props.history];
  newHistory.push({
    id: props.lastId,
    edited_at: props.lastTime,
    old_text: props.lastText,
  })

  const lastEditedAt = newHistory[newHistory.length - 1].edited_at;
  for (let i = newHistory.length - 1; i > 0; i--) {
    newHistory[i].edited_at = newHistory[i - 1].edited_at;
  }

  newHistory[0].edited_at = lastEditedAt;

  emit('showHistory', newHistory)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.history[0].old_text), 1),
    _createVNode(_unref(ArrowNarrowRight), { size: 16 }),
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.lastText), 1),
    _createElementVNode("div", {
      class: "additional",
      onClick: showHistory
    }, [
      _createVNode(_unref(DotsVertical), { size: 16 })
    ])
  ]))
}
}

})